import { combineReducers } from "redux";
import notification from "../features/serviceadmin/notification/Slice";

const serviceNotification = combineReducers({
  notification: notification,
});

export default serviceNotification;
